<template >
<div class="page-start" >
    <mdb-row>
        <mdb-btn class='QuadrusButton backBtn floatingBtn' type="submit" v-on:click="backToLogin">
            <mdb-icon color="white" fas icon="fas fa-chevron-left" />&nbsp;Back to Login
        </mdb-btn>
    </mdb-row>
    <div style="display: flex;">
    <mdb-container class="col-10 pb-3" id="container" fluid>        
            <mdb-card class="p-1">
                <mdb-card-body>
                    <h2 class="h2-responsive text-center mb-4">Quadrus Corporation SMS (Texting) Policy</h2>
                    
                    <div id="optin" class="text-left disclaimerDiv">
                        <h3 id="optinTitle" class="h3-responsive mb-4">Opt-In Information:</h3>
                        <div class="scrollableDiv">
                            <p>The following SMS consent form is provided by IT Support and is completed and signed by employees who choose to enroll. 
                                Completed forms are stored within an internal Quadrus Corporation database.</p>
                            <div class="justify-content-center d-flex">
                                <pdf-preview-btn :url="pdfUrl" name="Quadrus SMS Consent Form"/>
                            </div>
                        </div>
                    </div>
                    <br>

                    <div id="privacy" class="text-left disclaimerDiv">
                        <h3 id="privacyTitle" class="h3-responsive mb-4">Privacy Policy</h3>
                        <div class="scrollableDiv">
                            <p>Quadrus Corporation collects employee mobile phone numbers only for the purpose of sending company-related SMS notifications.</p>
                            <p>Information collected may include:</p>
                            <ul>
                                <li>Employee name</li>
                                <li>Mobile phone number</li>
                                <li>SMS enrollment consent</li>
                            </ul>
                            <p>Phone numbers are used only for operational communications, including IT, security, and business notifications. 
                                Quadrus Corporation does not sell, rent, or share phone numbers for marketing purposes.</p>
                            <p>SMS delivery services may be provided through authorized third-party providers, such as Microsoft Azure Communication Services.</p>
                            <p>Employees may request removal from SMS notifications at any time by contacting the IT department.</p>
                            <p>For questions regarding this policy, contact: <a href="mailto:Info@quadruscorp.com">Info@quadruscorp.com</a></p> 
                        </div>
                    </div>
                    <br>

                    <div id="terms" class="text-left disclaimerDiv">
                        <h3 id="termsTitle" class="h3-responsive mb-4">Terms and Conditions</h3>
                        <div class="scrollableDiv">
                            <p>By opting in to receive SMS messages from Quadrus Corporation, employees agree to receive operational notifications related to 
                                IT systems, security, and business operations.</p>
                            <p>Message frequency varies based on company needs. Message and data rates may apply.</p>
                            <p>Employees may opt out at any time by replying <b>STOP</b> to any SMS message. Employees may reply <b>HELP</b> for assistance or contact the IT department.</p>
                            <p>Quadrus Corporation does not send marketing or promotional SMS messages through this program.</p>
                            <p>For questions, contact: <a href="mailto:Info@quadruscorp.com">Info@quadruscorp.com</a></p>
                        </div>
                    </div>
                    
                </mdb-card-body>

        </mdb-card>

    </mdb-container>
    </div>	
</div>
</template>

<script>
import {  mdbBtn, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbIcon} from 'mdbvue';
import PdfPreviewBtn from '@/components/pdfPreviewBtn.vue';

export default {
	name: "Login-export",
	components: {
		mdbBtn,
		mdbCard,
		mdbCardBody,
		mdbContainer,
        mdbRow,
        mdbIcon,
        PdfPreviewBtn,
	},
	data () {
		return {
            pdfUrl: '/Quadrus SMS Consent Form.pdf',
            docName: 'Quadrus SMS Consent Form'
		}
	},


	methods: {
        backToLogin: function() {
            this.$router.push('/login');
        }	
	},
    mounted() {
        if(this.$route.hash == "#optin") {
            document.getElementById("optin").classList.add("highlight-section");
        } else if(this.$route.hash == "#privacy") {
            document.getElementById("privacy").classList.add("highlight-section");
        } else if(this.$route.hash == "#terms") {
            document.getElementById("terms").classList.add("highlight-section");
        }
    }
}
</script>

<style scoped>
.logo {
	padding-top: 20px;
	padding-bottom: 20px;
}
.login {
	background-color: #1b365d;
}
.scrollableDiv {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 10px;
    max-height: 500px;
    overflow-y: scroll;
}
.disclaimerDiv{
    padding: 10px;
}

@keyframes glow {
  0% {
    box-shadow: 0 0 0 rgba(0,0,0,0);
  }
  30% {
    box-shadow: 0 0 20px rgba(66, 133, 244, .5);
  }
  100% {
    box-shadow: 0 0 0 rgba(0,0,0,0);
  }
}

.highlight-section {
  border-radius: 5px;
  animation: glow 3s ease-out;
}
</style>